var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 15.7502C9.66667 15.7502 9.5 15.6627 9.33333 15.4877L5.25 11.1127C4.91667 10.7627 4.91667 10.2377 5.25 9.8877C5.58333 9.5377 6.08333 9.5377 6.41667 9.8877L9.91667 13.5627L18.1667 4.9002C18.5 4.5502 19 4.5502 19.3333 4.9002C19.6667 5.2502 19.6667 5.7752 19.3333 6.1252L10.5833 15.4877C10.4167 15.5752 10.1667 15.7502 9.91667 15.7502Z",
    fill: "url(#paint0_linear_2547_1192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 15.7501C5.58366 15.7501 5.41699 15.6626 5.25033 15.4876L1.16699 11.2001C0.833659 10.8501 0.833659 10.3251 1.16699 9.9751C1.50033 9.6251 2.00033 9.6251 2.33366 9.9751L6.41699 14.2626C6.75033 14.6126 6.75033 15.1376 6.41699 15.4876C6.25033 15.6626 6.08366 15.7501 5.83366 15.7501ZM10.2503 11.1126C10.0003 11.1126 9.83366 11.0251 9.66699 10.8501C9.33366 10.5001 9.33366 9.9751 9.66699 9.6251L14.0837 4.9876C14.417 4.6376 14.917 4.6376 15.2503 4.9876C15.5837 5.3376 15.5837 5.8626 15.2503 6.2126L10.8337 10.8501C10.667 11.0251 10.5003 11.1126 10.2503 11.1126Z",
    fill: "url(#paint1_linear_2547_1192)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_1192",
    x1: 12.2917,
    y1: 4.6377,
    x2: 12.2917,
    y2: 15.7502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2547_1192",
    x1: 8.20866,
    y1: 4.7251,
    x2: 8.20866,
    y2: 15.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/double-tick.e35e6d5b9cd6aba5fb97946a3bba0830.svg";
export { ForwardRef as ReactComponent };